import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { BetaList } from '@/pages/beta/BetaList'
import { Dashboard } from '@/pages/Dashboard'
import { Login } from '@/pages/Login'
import { MonitorOverview } from '@/pages/monitor/MonitorOverview'
import { RequestLog } from '@/pages/monitor/RequestLog'
import { StorageBrowser } from '@/pages/monitor/StorageBrowser'
import { CronLog } from '@/pages/system/CronLog'
import { SystemOverview } from '@/pages/system/SystemOverview'
import { TwoFactorSetup } from '@/pages/TwoFactorSetup'
import { TwoFactorVerify } from '@/pages/TwoFactorVerify'
import { Unauthorized } from '@/pages/Unauthorized'
import { Users } from '@/pages/Users'
import { UserDetail } from '@/pages/users/UserDetail'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/2fa/verify" element={<TwoFactorVerify />} />
        <Route path="/2fa/setup" element={<TwoFactorSetup />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        <Route path="/" element={<Dashboard />} />
        <Route path="/beta" element={<BetaList />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/:id" element={<UserDetail />} />
        <Route path="/monitor" element={<MonitorOverview />} />
        <Route path="/monitor/requests" element={<RequestLog />} />
        <Route path="/monitor/storage" element={<StorageBrowser />} />
        <Route path="/system" element={<SystemOverview />} />
        <Route path="/system/cron" element={<CronLog />} />
      </Routes>
    </BrowserRouter>
  )
}
